import { ApiService } from '../../core/services/api'
import { Skill } from '@/modules/core/models'
import { Dictionary } from 'vuex'
import _ from "lodash";

const SkillService = {

  list: async function (page: Number, size: Number, filters?: Dictionary<any>): Promise<Array<Skill>> {

    let query_params = { 'page': page, 'page_size': size};


    if (filters){
      _.mapKeys(filters, function(value, key) {
        query_params[key] = value;
      });
    }
    

    const response = await ApiService.get('user/skills/', query_params)

    let listSkills : Array<Skill> = [];
    for (let json of response.data.results) {
      let user = Skill.fromJson(json) as Skill;
      listSkills.push(user);
    }
    return listSkills;
  }

}

export { SkillService }
